jQuery(document).ready(function($) {
	// Fix for header on load
	$('#site-wrapper header').css('position', 'absolute');
	var logo_url = $('.navbar-brand img').attr('src');


		  
	setTimeout(function(){
		$(".courses-cards").css({ 'visibility': "visible" });
	}, 1000);
		
	// Mobile menu trigger
	var mMenu = $('#mobile-menu');
	mMenu.show();
	mMenu.mmenu({
		// options
		// panel: '.logo-tile',
		navbar: {
			// add: false
			title : ''
		},
		"navbars": [
			{
				"position": "bottom",
				"content": [
				"<a class='fa fa-phone' href='tel:+41263213434'> <span>+41 (0)26 321 34 34</span></a>",
				]
			}
		],
		"extensions": [
			"pagedim-black"
		],

	});
	var API = mMenu.data( 'mmenu' );
	var $icon = $('.mobile-menu-trigger');
	$icon.click(function() {
		 API.open();
	});
	API.bind( "opened", function() {
		$icon.addClass( "is-active" );
	});
	API.bind( "closed", function() {
		$icon.removeClass( "is-active" );
	});
	// close mobile menu on click link with href="#" 
	$('.closeMmenu').click(function() {
		API.close();
	});

	$('#mm-blocker').click(function() {
        $('#mobile-menu3').attr('style', 'display: none;');

     });

	


	////////////////////////
	// INPUT RESTRICTIONS //
	////////////////////////
	$('input.phone-number-restriction').alphanum({
		allow              : '-+/',    // Allow extra characters
		disallow           : '',    // Disallow extra characters
		allowSpace         : true,  // Allow the space character
		allowNewline       : false,  // Allow the newline character \n ascii 10
		allowNumeric       : true,  // Allow digits 0-9
		allowUpper         : true,  // Allow upper case characters
		allowLower         : true,  // Allow lower case characters
		allowCaseless      : true,  // Allow characters that do not have both upper & lower variants
									// eg Arabic or Chinese
		allowLatin         : false,  // a-z A-Z
		allowOtherCharSets : false,  // eg é, Á, Arabic, Chinese etc
		forceUpper         : false, // Convert lower case characters to upper case
		forceLower         : false, // Convert upper case characters to lower case
		maxLength          : 32    // eg Max Length
	});

	$('input.zip-restriction').alphanum({
		allow              : '-',    // Allow extra characters
		disallow           : '',    // Disallow extra characters
		allowSpace         : true,  // Allow the space character
		allowNewline       : false,  // Allow the newline character \n ascii 10
		allowNumeric       : true,  // Allow digits 0-9
		allowUpper         : true,  // Allow upper case characters
		allowLower         : true,  // Allow lower case characters
		allowCaseless      : true,  // Allow characters that do not have both upper & lower variants
									// eg Arabic or Chinese
		allowLatin         : true,  // a-z A-Z
		allowOtherCharSets : false,  // eg é, Á, Arabic, Chinese etc
		forceUpper         : false, // Convert lower case characters to upper case
		forceLower         : false, // Convert upper case characters to lower case
		maxLength          : 16    // eg Max Length
	});

	$('input.text-restriction').alpha({
		allow: "'-",
	});

	

	// Carousel
	var config = {
		items: 1,
		autoplay: true,
		autoplayTimeout: 4000,
		loop: true,
		smartSpeed: 1000,
		lazyLoad:true
		// dots: false,
	};
	// Check if there is only one slide
	if( $('.single-slide').length == 1 ){
		config.loop = false;
		config.dots = false;
	}
	// Initialize Carousel
	var heroSlide = $('.frilingue-carousel');
	heroSlide.owlCarousel(config);
	heroSlide.show();

	// School Photos Carousel
	var photoSlide = $('.photo-carousel');
	photoSlide.owlCarousel({
		items: 1,
		lazyLoad:true,
		//loop: true
	});

	// School Videos Carousel
	var videoSlide = $('.video-carousel');
	var videoSlideOwl = videoSlide.owlCarousel({
		items: 1,
		lazyLoad:true,
		//loop: true
	});

	var videoSlidetest = $('.video-carousel-testis');
	var videoSlideOwl2 = videoSlidetest.owlCarousel({
		items: 1,
		lazyLoad:true
	});
		


	// Add to Favorite School
	$('.favorite').on('click', function(){
		$(this).toggleClass('it-is');
	});


	// Fancybox
	$('[data-fancybox="image"]').fancybox({
		openEffect	: 'elastic',
		closeEffect	: 'elastic',
				helpers: {
					overlay: {
						locked: false
					}
				}
	});

	$('[data-fancybox="iframe"]').fancybox({
		openEffect	: 'elastic',
		closeEffect	: 'elastic',
				helpers: {
					overlay: {
						locked: false
					}
				}
	});

	// Search form width
	var w = window.innerWidth;
	var containerW = $('nav.navbar-static-top > .container').width();
	var searchMobile = $('#search-form-mobile-menu');
	var callSearch = searchMobile.find('#sb-search-toggle');

	function triggerSeachWidth(){
		callSearch.on('click', function() {
			searchMobile.find('.sb-search').width(containerW);
		});
	}

	if( w <= 576 ){
		$(window).load( triggerSeachWidth());

		$(window).resize(function(){
			containerW = $('nav.navbar-static-top > .container').width();
			triggerSeachWidth();
		});
	}
		
	// Toggle text box
	var toggleBox = $('#school-tab');
	var textWrapper = toggleBox.find('.text-wrapper');
	var toggleLink = toggleBox.find('a.card-link');
	var autoHeight = textWrapper.innerHeight();
	var defaultLinkTxt = toggleLink.html();
	// var initHeight = toggleBox.css('height', 220);
	var speed = 500;
	

	if(textWrapper.innerHeight() > 180 ){
		textWrapper.css('height', 180);
		toggleLink.show();
	
	}
	// toggleLink.click(function() {
	// 	if ( textWrapper.innerHeight() == 180){
	// 		textWrapper.animate({ 'height': autoHeight }, speed );
	// 		toggleLink.find('.read-more').hide();
	// 		toggleLink.find('.read-less').show();
    //
	// 	}else if ( textWrapper.innerHeight() == autoHeight ){
	// 		textWrapper.animate({ 'height': 180 }, speed );
	// 		toggleLink.find('.read-more').show();
	// 		toggleLink.find('.read-less').hide();
	// 	}
	// });


	textWrapper.animate({ 'height': autoHeight }, speed );
	toggleLink.find('.read-more').hide();
	toggleLink.find('.read-less').show();


	
	$('ul.nav li.dropdown.custom-pages').hover(function () {
		$(this).find('.dropdown-menu').stop(true, true).fadeIn(200);
	}, function () {
		$(this).find('.dropdown-menu').stop(true, true).fadeOut(200);
	});
	
	// code for moving placeholders
	$('.moving-placeholder input, .moving-placeholder textarea').focusin(function() {
		$(this).siblings('span').addClass('input-populated');
	}); 
		
	$('.moving-placeholder input, .moving-placeholder textarea').focusout(function() {
		if( $(this).val() == '' ) {
			$(this).siblings('span').removeClass('input-populated');
		}
	});

	// if check if value is already populated
	$('.moving-placeholder input, .moving-placeholder textarea').each(function(index, el) {
		if( $(this).val() != '' ){
			$(this).siblings('span').addClass('input-populated');
		}
	});
	
	$('.moving-placeholder input, .moving-placeholder textarea').change(function() {
		if( $(this).val() == '' ) {
			$(this).siblings('span').removeClass('input-populated');
		}else{
			$(this).siblings('span').addClass('input-populated');
		}
	});

	// datetime picker
	$('.datetimepicker').datetimepicker({ dateFormat:'dd/mm/yy', timeFormat:'HH:mm', 'minDate':0 });


	// Masonry
	var getAll = $('#get-all');
	var masonryBox = $('.grid');
	var numberOfBoxes = $('.grid-item').length;
	var Box = $('.grid-item');
	setTimeout(function() {
		masonryBox.masonry({
			columnWidth: '.grid-sizer',
			gutter: '.gutter-sizer',
			itemSelector: '.grid-item',
			percentPosition: true,
			stamp: '.spacer'

		});
		masonryBox.find('.card-block').show();
		// console.log('boxova: ' + numberOfBoxes);
	}, 1000);

	if(numberOfBoxes > 9){
		Box.slice(9).hide();
		getAll.show().css('display', 'block');
	}
	getAll.on('click', function(event) {
		event.preventDefault();
		var newBoxes = masonryBox.find('.grid-item:hidden').show();
		var hiddenBoxes = masonryBox.masonry('getItemElements');
		masonryBox.masonry('appended', newBoxes);
		masonryBox.masonry('reloadItems');
		masonryBox.masonry('layout');
		$(this).hide();
	});




	/**
	 * Close accordion on tab change
	 * Toggle arrow icon UP and DOWN
	 */
	var aboutSchoolNavi = $('.about_school .card:first-child .nav li:not(:nth-child(2)) > a');
	var priceTab = $('#price-tab');
	var accordionHeader = priceTab.find('.card-header');

	accordionHeader.on('click', function(){
		$(this).find('i.fa').toggleClass('fa-chevron-down fa-chevron-up');
	});

	aboutSchoolNavi.on('click', function(){
		if(accordionHeader.attr('aria-expanded') === "true"){
			priceTab.find('.collapse.in').collapse('hide');
			priceTab.find('i.fa').toggleClass('fa-chevron-down fa-chevron-up');
		}
	});




	// Fit text in container
	var $captionTitle = $('.jumbotron .caption h1, .caption h1'),
		$captionTagline = $('.jumbotron .caption h2, .title-tag'),
		$campsJumbotronTitle = $('.jumbotron.camps-jumbotron .caption h1'),
		$campsJumbotronTag = $('.jumbotron.camps-jumbotron .caption .title-tag'),
		$sectionTitle = $('h1.section-title'),
		$siteTitle = $('.container.sub-header h1.site-title, .step_01_subheader h1'),
		$cardTitle = $('.card.card-block h2');

		$siteTitle.fitText(1.2,{
			minFontSize: '20px',
			maxFontSize: '60px',
		});
		$sectionTitle.fitText(1.2,{
			minFontSize: '20px',
			maxFontSize: '60px',
		});

		$captionTitle.fitText(1.2, {
			minFontSize: '26px',
			maxFontSize: '65px'
		});
		$captionTagline.fitText(1.2, {
			minFontSize: '20px',
			maxFontSize: '36px'
		});

		if ($campsJumbotronTag.length > 25) {
			$campsJumbotronTag.fitText(1.2, {minFontSize: '20px', maxFontSize: '50px'});
			$campsJumbotronTitle.fitText(1.2, {minFontSize: '16px', maxFontSize: '30px'});
		}else {
			$campsJumbotronTag.fitText(1.2, {minFontSize: '26px', maxFontSize: '65px'});
			$campsJumbotronTitle.fitText(1.2, {minFontSize: '20px', maxFontSize: '36px'});
		}




	/**
	 * Mega menu fix to top after scrolling 
	 */
	var stickyOffset = $('#sub-menu').offset().top + 67;
	var sticky = $('#sub-menu');
	var subMega = $('.sub-mega');
	var liDropdown = sticky.find('.mega-menu-holder > .has-submenu');
	var toggleDropdown = liDropdown.find('a.dropdown-toggle');

	$(window).scroll(function(){
		scroll = $(window).scrollTop();
		if (scroll >= stickyOffset) sticky.addClass('stickyMegaMenu');
		else sticky.removeClass('stickyMegaMenu');
	});

	// leave open dropdown on click inside of it
	subMega.click(function(event) {
		if( $(event.target)[0].nodeName != 'A' ) return false;
	});


	// On click menu item scroll to top
	liDropdown.on('click', function(){
		$('html, body').animate({
			scrollTop: sticky.offset().top
		}, 300);
	});



	$.validator.methods.email = function( value, element ) {
		return this.optional( element ) || /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test( value );
	};


	// var scrollTable = $('#accommodation-tab');
	$(".mCustomScrollbar").mCustomScrollbar({
		axis:"x"
	});


	/**
	 * Smile rating system
	 */
	var $radioRating = $('.page-front-reviews-create .radio-rating');

	$radioRating.each(function(index, el) {
		// Find label that was hoverd and add class
		$(el).find('label').mouseenter(function() {
			var max_value = $(this).closest('span').find('input').val();

			$(this).closest('.radio-rating').find('span').each(function(index, el) {
				if( $(el).find('input').val() <= max_value ){
					$(el).addClass('hover');
				}
			});
		});
		// Remove class when mouse leaves 
		$(el).find('label').mouseleave(function() {
			var selected_value = 0;

			$(this).closest('.radio-rating').find('input').each(function(index, el) {
				if( $(el).is(':checked') ) selected_value = $(el).val();
			});

			$(this).closest('.radio-rating').find('span').each(function(index, el) {
				if(selected_value == 0){
					$(el).removeClass('hover');
				}else{
					if( $(el).find('input').val() <= selected_value ){
						$(el).addClass('hover');
					}else{
						$(el).removeClass('hover');
					}
				}
			});
		});
		// Add class on all previous siblings to clicked label
		$(el).find('label').click(function(event) {
			var max_value = $(this).closest('span').find('input').val();

			$(this).closest('.radio-rating').find('span').each(function(index, el) {
				if( $(el).find('input').val() <= max_value ){
					$(el).addClass('hover');
				}else{
					$(el).removeClass('hover');
				}
			});
		});

	});

	/**
	 * Show button in the bottom of Reviews page if there is more than 10 reviews
	 */
	var $bottomButton = $('.page-front-reviews-index div.invisible');
	var n = $('.page-front-reviews-index .main-block-text > ul.list-unstyled li').length;
	if(n >= 10){
		$bottomButton.removeClass('invisible');
	}


// EOF // 
});